define('__original__/BookingStepManager',['require','marionette','controller/step/ServiceStep','controller/step/ProviderStep','controller/step/datetime/SlotsDateTimeStep','controller/step/datetime/SlotsWeeklyDateTimeStep','controller/step/datetime/FlexibleDateTimeStep','controller/step/datetime/FlexibleWeeklyDateTimeStep','controller/step/datetime/EventDateTimeStep','controller/step/datetime/ClassesTimeStep','controller/step/datetime/FlexibleProviderDateTimeStep','controller/step/datetime/GridWeeklyDateTimeStep','controller/step/DetailsStep','lib/plugin/PluginBroker','Config','lib/view/BookingUrlBuilder'],function (require) {

	var Marionette = require('marionette');

	var ServiceStep = require('controller/step/ServiceStep');
	var ProviderStep = require('controller/step/ProviderStep');
	var SlotsDateTimeStep = require('controller/step/datetime/SlotsDateTimeStep');
	var SlotsWeeklyDateTimeStep = require('controller/step/datetime/SlotsWeeklyDateTimeStep');
	var FlexibleDateTimeStep = require('controller/step/datetime/FlexibleDateTimeStep');
	var FlexibleWeeklyDateTimeStep = require('controller/step/datetime/FlexibleWeeklyDateTimeStep');
	var EventDateTimeStep = require('controller/step/datetime/EventDateTimeStep');
	var ClassesTimeStep = require('controller/step/datetime/ClassesTimeStep');
	var FlexibleProviderDateTimeStep = require('controller/step/datetime/FlexibleProviderDateTimeStep');
	var GridWeeklyDateTimeStep = require('controller/step/datetime/GridWeeklyDateTimeStep');
	var DetailsStep = require('controller/step/DetailsStep');
	var PluginBroker = require('lib/plugin/PluginBroker');
	var Config = require('Config');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');

	/**
	 * Step builder lass. Builds step objects
	 *
	 * @class BaseStep
	 */
	return Marionette.Object.extend({

	    _bookingModel: null,
        _timeValidateModel: null,
	    _stepObjects: null,

	    _steps: null,
		_hiddenSteps: null,

	    /**
	     * Inits instance
	     */
	    initialize: function() {
            this._stepObjects = {};
            this._steps = ['service', 'provider', 'datetime', 'details'];
            this._hiddenSteps = [];
	        this._bookingModel = this.getOption('bookingModel');
	        this._timeValidateModel = this.getOption('timeValidateModel');

            jQuery(window).bind('message', _.bind(
                _.throttle(this._handleWindowMessage, 100), this
            ));

	        this._steps = PluginBroker.getInstance().modifySteps(this._steps);
            this._reformatSteps();

			this.trigger('stepsChanged');
	    },

        /**
		 * Initialize steps
         */
		initializeSteps: function () {
			if (_.isEmpty(this._stepObjects)) {
                _.each(this.getSteps(), function (step) {
                    var stepObj = this.getStepObject(step);
                    if (stepObj) {
                        stepObj.initStep();
                    }
                }, this);

                _.each(this.getSteps(), function (step) {
                    var stepObj = this.getStepObject(step);
                    if (stepObj) {
                        stepObj.triggerInit();
                    }
                }, this);
            }
        },
        
        clearSteps: function () {
            this._stepObjects = {};
        },
        
        clearCollectionFilters: function () {
            _.each(this._stepObjects, function (stepObj) {
                stepObj.clearCollectionFilters();
            }, this);
        },

        _handleWindowMessage: function (event) {
            var data = event.originalEvent.data;
            if (_.isObject(data) && data.update_config) {
                this.clearSteps();
            }
        },

        /**
         * Returns booking model
         *
         * @returns BookingModel
         */
		getBookingModel: function () {
            return this._bookingModel;
        },

        /**
         * Returns time validate model
         *
         * @returns BookingModel
         */
		getTimeValidateModel: function () {
            return this._timeValidateModel;
        },

	    /**
	     * Returns step object by name
	     *
	     * @param String name
	     * @return BaseStep
	     */
	    getStepObject: function (step) {
	    	if (!this._stepObjects[step]) {
	    		this._stepObjects[step] = this._instantiateStepObject(step);
	    	}
	    	return this._stepObjects[step];
	    },

        /**
         * Reorder/reformat steps depends on config
         *
         * @private
         */
        _reformatSteps: function () {
        	var classesTimelines = [Config.TIMELINE_CLASSES];
            if (_.contains(classesTimelines, Config.getInstance().getTimelineType())) {
                // skip service and provider steps for classes timeline
                this._skipSteps(['service', 'provider']);
            }
            if (Config.getInstance().getTimelineType() === Config.TIMELINE_FLEXIBLE_PROVIDER) {
                // skip service and provider steps for classes timeline
                this._skipSteps(['provider']);
            }
            if (Config.getInstance().getTimelineType() === Config.TIMELINE_GRID_WEEKLY) {
                // skip service and provider steps for classes timeline
                this._skipSteps(['service', 'provider', 'location', 'category']);
            }
        },

        /**
		 * Remove steps from stack
		 *
         * @param steps
         * @private
         */
        _skipSteps: function (steps) {
            _.each(steps, function (value) {
                var index = _.indexOf(this._steps, value);
                if (index >= 0) {
                    this._steps.splice(index, 1);
                }
            }, this);
        },

        /**
		 * Adds step after afterStep
		 *
         * @param steps
         * @param afterStep
         * @private
         */
		_insertSteps: function (steps, afterStep) {
            this._steps.splice(this._steps.indexOf(afterStep), 0, steps);
		},

	    /**
	     * Instantiate step object by name
	     *
	     * @param String step
	     * @return BaseStep
	     */
	    _instantiateStepObject: function (step) {
	    	var stepParams = _.extend(
	    		this.getOption('stepParams'), {
	    			stepManager: this,
    				bookingModel: this._bookingModel
    			}
			);

	    	var res = PluginBroker.getInstance().getStep(step, stepParams);
	    	if (!res) {
	    		switch (step) {
	    			case 'service':
	    				res = new ServiceStep(stepParams);
	    				break;
	    			case 'provider':
	    				res = new ProviderStep(stepParams);
	    				break;
	    			case 'datetime':
	    				res = this._getTimelineStepInstance(stepParams);
	    				break;
	    			case 'details':
	    				res = new DetailsStep(stepParams);
	    				break;
	    		}
	    	}

	    	this.listenTo(res, 'done', this.onStepDone);

	    	return res;
	    },

	    /**
	     * Returns next step name
	     *
	     * @return String
	     */
	    getNextStep: function (nextTo) {
	    	var from = 0;
	    	if (nextTo) {
				from = this._steps.indexOf(nextTo) + 1;
			}
	    	for (var i = from; i < this._steps.length; i++) {
	    		var stepObj = this.getStepObject(this._steps[i]);
	    		if (!stepObj) {
	    			return null;
	    		}
	    		if (!stepObj.isValid()) {
	    			return this._steps[i];
	    		}
	    	}
	    },

        getSteps : function () {
            return this._steps;
        },

		getVisibleSteps: function () {
			var steps = [];
			var predefined = Config.getInstance().getOption('predefined') || {};

			_.each(this.getSteps(), function (step, index) {
				if (this._hiddenSteps.indexOf(step) === -1 && !predefined[step]) {
					steps.push(step);
				}
			}, this);

			return steps;
		},

		isStepHidden : function(step){
	    	var visibleSteps = this.getVisibleSteps();
	    	return !visibleSteps || visibleSteps.indexOf(step) === -1;
		},

		hideStep: function (step) {
            var index = this._hiddenSteps.indexOf(step);
			if (index == -1) {
			    this._hiddenSteps.push(step);
            }
			this.trigger('stepsChanged');
		},

		showStep: function (step) {
			var index = this._hiddenSteps.indexOf(step);
			if (index > -1) {
				this._hiddenSteps.splice(index, 1);
			}

			this.trigger('stepsChanged');
		},

	    /**
	     * Calling when step is done. Triggers stepDone event, to show next step
	     */
	    onStepDone: function () {
	    	this.trigger('stepDone');
	    },

        /**
         * Call it when booking is done. Triggers bookingDone event, to show next to details step
         */
        bookingDone: function (requestModel) {
            this.trigger('bookingDone', requestModel);
        },

		/**
		 * Creates timeline instance based on config
		 *
		 * @param Object stepParams
		 * @private
		 */
		_getTimelineStepInstance: function (stepParams) {
			//console.log(Config.getInstance().getTimelineType());

			switch (Config.getInstance().getTimelineType()) {
				case Config.TIMELINE_SLOTS:
					return new SlotsDateTimeStep(stepParams);
				case Config.TIMELINE_SLOTS_WEEKLY:
					return new SlotsWeeklyDateTimeStep(stepParams);
				case Config.TIMELINE_FLEXIBLE:
					return new FlexibleDateTimeStep(stepParams);
				case Config.TIMELINE_FLEXIBLE_WEEKLY:
					return new FlexibleWeeklyDateTimeStep(stepParams);
				case Config.TIMELINE_CLASSES:
					return new ClassesTimeStep(stepParams);
				case Config.TIMELINE_EVENT:
					return new EventDateTimeStep(stepParams);
				case Config.TIMELINE_FLEXIBLE_PROVIDER:
					return new FlexibleProviderDateTimeStep(stepParams);
				case Config.TIMELINE_GRID_WEEKLY:
					return new GridWeeklyDateTimeStep(stepParams);
				default:
					// default time step.
                    return new SlotsWeeklyDateTimeStep(stepParams);
			}
		},
        
        getRouteName: function () {
            return 'booking_step';
        },
        
        getUrlBuilder: function () {
            return BookingUrlBuilder.getInstance();
        }

	});

});

